module.exports = __webpack_public_path__ + "img/BIRTHDAY-EVENTS.8ae82ec5.jpg";